export const ColoursByStrength = {
  poor: '#E35F67',
  weak: '#E67E22',
  average: '#F1C84F',
  fine: '#799DBF',
  strong: '#96B379',
};
